import React from 'react';
import SkeletonLoader from '@components/SkeletonLoader/SkeletonLoader';
import {
  SkeletonContainer,
  SkeletonItemContainer,
  SkeletonIconContainer,
  SkeletonDetailsContainer,
  SkeletonLeftSide,
  SkeletonRightSide,
  Divider
} from './ActivityList.styles';

type ActivityListSkeletonProps = {
  itemCount?: number;
};

const ActivityListSkeleton: React.FC<ActivityListSkeletonProps> = ({ itemCount = 5 }) => {
  return (
    <SkeletonContainer>
      {Array.from({ length: itemCount }).map((_, index) => (
        <React.Fragment key={index}>
          <SkeletonItemContainer>
            <SkeletonIconContainer>
              <SkeletonLoader width="24px" height="24px" borderRadius="50%" />
            </SkeletonIconContainer>
            <SkeletonDetailsContainer>
              <SkeletonLeftSide>
                <SkeletonLoader width="120px" height="16px" />
                <SkeletonLoader width="80px" height="14px" />
              </SkeletonLeftSide>
              <SkeletonRightSide>
                <SkeletonLoader width="90px" height="16px" />
                <SkeletonLoader width="70px" height="14px" />
              </SkeletonRightSide>
            </SkeletonDetailsContainer>
          </SkeletonItemContainer>
          {index !== itemCount - 1 && <Divider />}
        </React.Fragment>
      ))}
    </SkeletonContainer>
  );
};

export default ActivityListSkeleton;
